import logo from './logo.svg';
import './App.css';
import './assets/css/wellness_screen.scss';
import './assets/css/silver_care.scss';
import './assets/css/navbar.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getCurrentLang } from './i18n';
import { BrowserRouter as Router, Redirect, Route, Routes } from "react-router-dom";
import React, { Component, Suspense, lazy } from 'react'


const WellnessScreen = lazy(() => import('./screen//WellnessScreen'))
const SilverCareScreen = lazy(() => import('./screen//SilverCareScreen'))




class App extends Component {
  render() {
    return (
      <Router basename={getCurrentLang() === "zh-hant" ?'':(getCurrentLang() === "cn"?'/cn': '/en' ) }>
        {/* <Routes>
          <Route path="/watch" element={<WatchScreen />} />
        </Routes> */}
        <Routes>
          <Route path="/" element={<WellnessScreen />} />
        </Routes>
        <Routes>
          <Route path="/silverCare" element={<SilverCareScreen />} />
        </Routes>
      </Router>
    )
  }
}

export default App;
